<template>
  <v-container class="py-0 px-2">
    <v-row>
      <v-col class="text-left px-0 py-6" cols="6">
        <h1 style="color: #430f4a">Itens selecionados para alteração</h1>
      </v-col>
      <v-col class="px-0 py-0" cols="12">
        <v-data-table
          :headers="tipoConsulta=='guias'? headerGuias : headerItens"
          :items="list"
          :items-per-page="itemsPerPage"
          :page.sync="page"
          hide-default-footer
          ref="EdicaoTable"
          class="edicaoListTable"
          min="-1"
          max="15"
          dense
        >
          <template v-slot:item.dt_execucao="{ item }">
            <span
              >{{ item.dt_execucao | formatDate }}
            </span>
          </template>
           <template v-slot:item.dt_autorizacao="{ item }">
            <span
              >{{ item.dt_autorizacao | formatDate }}
            </span>
          </template>

         <template v-slot:item.conselho_profissional="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div  style="min-width: 80px; max-width: 100px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                {{getDescricaoDominio('dm_conselhoProfissional', item.conselho_profissional)}}
                </div>
              </template>
              <span>{{getDescricaoDominio('dm_conselhoProfissional', item.conselho_profissional)}}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.cbos="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div  style="min-width: 80px; max-width: 100px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                {{getDescricaoDominio('dm_CBOS', item.cbos)}}
                </div>
              </template>
              <span>{{getDescricaoDominio('dm_CBOS', item.cbos)}}</span>
            </v-tooltip>
          </template>


          <template v-slot:item.codigo_tabela="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div  style="min-width: 80px; max-width: 100px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                {{getDescricaoDominio('dm_tabela', item.codigo_tabela)}}
                </div>
              </template>
              <span>{{getDescricaoDominio('dm_tabela', item.codigo_tabela)}}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.valor_unitario="{ item }">
            <span
              >{{ item.valor_unitario | formatPrice }}
            </span>
          </template>
          <template v-slot:item.valor_total="{ item }">
            {{ item.valor_total | formatPrice }}
          </template>
        </v-data-table>
      </v-col>
      <v-col class="pa-1" cols="4"></v-col>
      <v-col class="pa-1" cols="4">
        <v-pagination
          class="no-box-shadow"
          v-model="page"
          :length="pageCount"
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment"
import { VMoney } from "v-money"
import { dragscroll } from 'vue-dragscroll'
export default {
  directives: { money: VMoney, dragscroll },
  data() {
    return {
      select: [],
      selectedExames: [],
      dateFormatted: null,
      date: null,
      dt: false,
      id_list: null,
      valor: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
      tabela: null,
      headerGuias: [
        { text: "Nº guia prestador", value: "numero_guia_prestador", sortable: false, },
        { text: "Data da autorização.", align: "center" , value: "dt_autorizacao", sortable: false, },
        { text: "Nome beneficiário", value: "nome_beneficiario", sortable: false, },
        { text: "Conselho profissional do executante", value: "conselho_profissional", sortable: false, },
        { text: "Cód. CBO do executante", value: "cbos", sortable: false, },
        { text: "Valor total (R$)", align: "end" , value: "valor_total", sortable: false },
      ],
      headerItens: [
        { text: "Nº guia prestador", value: "numero_guia_prestador", sortable: false, },
        { text: "Nome beneficiário", value: "nome_beneficiario", sortable: false, },
        // { text: "Valor total (R$)", align: "end" , value: "valor_total", sortable: false },
        { text: "Procedimentos/ Outras despesas", value: "tipo", sortable: false, },
        { text: "Data Execução", align: "date" ,value: "dt_execucao", sortable: false },
        { text: "Tabela", width: "1px" , align:"center", value: "codigo_tabela", sortable: false, },
        { text: "Seq. item", align:"center" , value: "sequencial_item", sortable: false },
        { text: "Item Vinculado", align:"center" , width: "1px" , value: "item_vinculado", sortable: false },
        { text: "Cód. Procedimento", value: "codigo_procedimento", sortable: false },
        { text: "Descrição Proced.", value: "descricao_procedimento", sortable: false },
        { text: "Quant.", align:"center",value: "qtd_executada", sortable: false },
        { text: "Valor unit. (R$)", width: "80px" , align:"end",value: "valor_unitario", sortable: false },
        { text: "Valor total (R$)", align:"end",value: "valor_total", sortable: false },
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
    };
  },
  watch:{
    list:{
      deep: true,
      handler(val){
        this.page = 1
        this.pageCount = (val.length % this.itemsPerPage)? parseInt(val.length/this.itemsPerPage)+1 : parseInt(val.length/this.itemsPerPage)
      }
    }
  },
  mounted() {
    if(this.tipo_guia == "SP-SADT"){
      this.headerGuias[3].text = "Cons. prof. do solicitante"
      this.headerGuias[4].text = "Cód. CBO do solicitante"
    } else {
      this.headerGuias[3].text = "Cons. prof. do executante"
      this.headerGuias[4].text = "Cód. CBO do executante"
    }
    this.page = 1
        this.pageCount = (this.list.length % this.itemsPerPage)? parseInt(this.list.length/this.itemsPerPage) +1 : parseInt(this.list.length/this.itemsPerPage)
  },
  methods: {
     getListIndex(nome_dominio){       
      let index = this.dominiosList.findIndex(el => el.dominio == nome_dominio)
      return  index
    },
    getDescricaoDominio(tabela, valor) {
      if(tabela=='dm_conselhoProfissional' && valor && valor.length==1){
        valor = valor.padStart(2, "0")
      }
      let dominioItem = this.dominiosList[this.getListIndex(tabela)].valores.find(el=> el.valor==valor)
      return dominioItem? dominioItem.descricao : (valor!=null? 'nº '+ valor : '')
    },
  },
  filters: {
    formatDate(date) {
        return moment(date).format("L");
        },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  props: {
    list: Array,
    tipoConsulta: String,
    formatDate: Function,
    parseDate: Function,
    dominiosList: Array
  }
};
</script>

<style>
.v-messages__message {
  font-size: 10px;
}
.edicaoListTable.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, 
.edicaoListTable.v-data-table > .v-data-table__wrapper > table > tbody > tr > th, 
.edicaoListTable.v-data-table > .v-data-table__wrapper > table > thead > tr > td, 
.edicaoListTable.v-data-table > .v-data-table__wrapper > table > thead > tr > th, 
.edicaoListTable.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, 
.edicaoListTable.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    font-size: 10px;
    padding: 0 4px;
    height: 16px
}
</style>